import { forwardRef } from 'react';
import { useTheme } from 'styled-components';

import { useBreakpoint } from '@hivebrite/design-system/Theme';
import { useIsMobileDevice } from '@hivebrite/react-hooks';

import { getAlignItems, getJustifyContent } from 'hb-builder/utils/attributes';
import { getNetworkColor } from 'hb-builder/utils/colors';
import { paddingOverride } from 'hb-builder/utils/mobile';

import { WrapperStyled } from './WrappersStyle';

const getWrapperStyle = ({ attributes, colors, isDragging, style }) => ({
  backgroundColor: getNetworkColor(
    style?.backgroundColor || attributes?.containerBackgroundColor,
    colors,
  ),
  alignItems: getAlignItems(attributes?.verticalAlign),
  justifyContent: getJustifyContent(attributes?.horizontalAlign),
  padding:
    !isDragging && attributes?.containerPadding
      ? attributes?.containerPadding
      : 0,
  width: '100%',
  ...style,
});

export const Wrapper = forwardRef(
  (
    {
      attributes = undefined,
      children,
      className = undefined,
      componentType,
      dataTestId,
      id = undefined,
      isMobilePreview,
      style = undefined,
    },
    ref,
  ) => {
    const isMobileDevice = useIsMobileDevice();
    const breakpoint = useBreakpoint();
    const theme = useTheme();

    const isMobile =
      isMobilePreview || isMobileDevice || ['s', 'm'].includes(breakpoint);

    return (
      <WrapperStyled
        className={className}
        $isDisabled
        $isMobile={isMobile}
        $paddingOverride={paddingOverride({
          keepContainerPaddingScreenS: attributes?.keepContainerPaddingScreenS,
          padding: attributes?.containerPadding,
          type: componentType,
        })}
        id={id}
        data-testid={dataTestId}
        ref={ref}
        style={getWrapperStyle({ attributes, colors: theme.colors, style })}
      >
        {children}
      </WrapperStyled>
    );
  },
);
